/* TODO: t() */
import React, { Component } from 'react';
import FormFieldEditor from '../helpers/FormFieldEditor';
import Editor from '../../../../core-ui/Editor/StatefulEditor';

import ContentElement from '../ContentElement';

type EditorViewProps = {
  data: {
    [key: string]: unknown;
  };
  updateValues: (data: { [key: string]: unknown }) => void;
};

function EditorView(props: EditorViewProps) {
  let { data, updateValues } = props;
  let text = typeof data.text === 'string' ? data.text : '';
  return (
    <div>
      <div className="label">Text</div>
      <div className="value">
        <Editor
          height={220}
          basicToolbar={true}
          contentClassName="form-content-element"
          initialContent={text}
          onChange={(content) => {
            updateValues({
              format: 'html',
              text: content.toString(),
            });
          }}
        />
      </div>
    </div>
  );
}

type Props = {
  parent: ContentElement;
};

class ContentElementFieldEditorView extends Component<Props> {
  render() {
    let { parent } = this.props;
    return <FormFieldEditor component={EditorView} parent={parent} />;
  }
}

export default ContentElementFieldEditorView;
